import * as PropTypes from 'prop-types'

export const withScrollDirection = () => (WrappedComponent) => {
  class WithScrollDirection extends React.PureComponent {
    static displayName = `withScrollDirection(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`

    lastScrollPosition = 0

    state = {
      isScrollingDown: false,
      isScrollingUp: false
    }

    setScrollDirection = () => {
      const scrollY = window.pageYOffset

      const {
        isScrollingDown,
        isScrollingUp
      } = this.state

      if (window.pageYOffset > this.lastScrollPosition) {
        if (!isScrollingDown) {
          this.setState({
            isScrollingDown: true,
            isScrollingUp: false
          })
        }
      } else if (window.pageYOffset < this.lastScrollPosition) {
        if (!isScrollingUp) {
          this.setState({
            isScrollingDown: false,
            isScrollingUp: true
          })
        }
      }

      this.lastScrollPosition = scrollY
    }

    async componentDidMount () {
      // Dynamically import because "window" is not defined when using SSR
      const module = await import('/javascripts/bus')
      this.bus = module.default

      this.bus.on('windowScroll', this.setScrollDirection)
    }

    componentWillUnmount () {
      this.bus.removeListener('windowScroll', this.setScrollDirection)
    }

    render () {
      return <WrappedComponent {...this.props} {...this.state} />
    }
  }

  WrappedComponent.propTypes = {
    ...WrappedComponent.propTypes,
    isScrollingDown: PropTypes.bool.isRequired,
    isScrollingUp: PropTypes.bool.isRequired
  }

  return WithScrollDirection
}
